// extracted by mini-css-extract-plugin
export default {"container":"Ij-z","blurb":"Jj-z","links":"Kj-z"};